import {
  Zap,
  BarChart3,
  Sparkles,
  MessageSquare,
  GitBranch,
  TrendingUp,
  CalendarDays,
  Radio,
  Sunrise,
  Target,
  Trophy,
  Star,
  Bot,
  type LucideIcon,
} from 'lucide-react';

export type WidgetSize = 'full' | 'half';

export interface DashboardWidgetDef {
  id: string;
  icon: LucideIcon;
  size: WidgetSize;
  pinned?: boolean;
  defaultOrder: number;
}

export const DASHBOARD_WIDGETS: DashboardWidgetDef[] = [
  { id: 'quick-actions',   icon: Zap,          size: 'full', pinned: true, defaultOrder: 0 },
  { id: 'stats',           icon: BarChart3,     size: 'full',              defaultOrder: 1 },
  { id: 'ai-suggestions',  icon: Sparkles,      size: 'half',              defaultOrder: 2 },
  { id: 'activity-feed',   icon: MessageSquare, size: 'half',              defaultOrder: 3 },
  { id: 'pipeline',        icon: GitBranch,     size: 'half',              defaultOrder: 4 },
  { id: 'trends',          icon: TrendingUp,    size: 'half',              defaultOrder: 5 },
  { id: 'calendar',        icon: CalendarDays,  size: 'half',              defaultOrder: 6 },
  { id: 'sales-radio',     icon: Radio,         size: 'half',              defaultOrder: 7 },
  { id: 'morning-brief',   icon: Sunrise,       size: 'half',              defaultOrder: 8 },
  { id: 'todays-focus',    icon: Target,        size: 'half',              defaultOrder: 9 },
  { id: 'top-priorities',  icon: Star,          size: 'half',              defaultOrder: 10 },
  { id: 'recent-wins',     icon: Trophy,        size: 'half',              defaultOrder: 11 },
  { id: 'echobot',         icon: Bot,           size: 'full',              defaultOrder: 12 },
];

export const WIDGET_MAP = new Map(DASHBOARD_WIDGETS.map(w => [w.id, w]));

export const DEFAULT_WIDGET_IDS = [
  'quick-actions',
  'stats',
  'ai-suggestions',
  'activity-feed',
  'pipeline',
  'trends',
  'calendar',
  'sales-radio',
  'echobot',
];

export const PINNED_WIDGET_IDS = DASHBOARD_WIDGETS
  .filter(w => w.pinned)
  .map(w => w.id);
